import { NgModule, SkipSelf, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { QRCodeWrapperModule } from '../shared/qrcode-wrapper.module';
import { SharedModule } from '../shared/shared.module';
import { AuthGuard } from '../core/auth.guard';

import {
  AIModelPricingComponent,
  TicketStatusComponent,
  UsersComponent

} from '.';
function throwIfAlreadyLoaded(parentModule: any, moduleName: string) {
  if (parentModule) {
    throw new Error(`${moduleName} has already been loaded. Import Core modules in the AppModule only.`);
  }
}


const routes: Routes = [
  { path: 'ai-model-pricing', component: AIModelPricingComponent, canActivate: [AuthGuard] },
  { path: 'ticket/status', component: TicketStatusComponent, canActivate: [AuthGuard] },
  { path: 'ticket/status/:ID', component: TicketStatusComponent, canActivate: [AuthGuard] },
  { path: 'users', component: UsersComponent, canActivate: [AuthGuard] },
];

const pages = [
    AIModelPricingComponent,
    TicketStatusComponent,
    UsersComponent
];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    QRCodeWrapperModule,
    RouterModule.forChild(routes)
  ],
  declarations: [
    ...pages   
  ],
  providers: []
})
export class AdminModule { 
  constructor(@Optional() @SkipSelf() parentModule: AdminModule) {
    if (parentModule) {
      throw new Error('Module is already loaded. Import in your base AppModule only.');
    }
  }
}
